import { store } from 'redux/store';
import { useEffect, useState } from 'react';
import { Share, SharesTitle } from 'types';
import { getSharesTitlesByShares } from 'modules/partners/api/getSharesTitlesByShares';

type UseGetShareTitlesBySharesProps = {
  shares: Share[];
};

export const UseGetShareTitlesByShares = ({
  shares,
}: UseGetShareTitlesBySharesProps) => {
  const [sharesTitles, setSharesTitles] = useState<SharesTitle[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    const fetchShares = async () => {
      if (!shares) return;

      try {
        setIsLoading(true);
        const sharesIds = shares.map((share) => share._id);

        const sharesTitles = await store.dispatch(
          getSharesTitlesByShares(sharesIds)
        );

        setSharesTitles(sharesTitles || []);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setIsError(true);
      }
    };

    fetchShares();
  }, [shares]);

  return {
    data: { sharesTitles },
    isLoading,
    isError,
    actions: {},
  };
};
